import { ROUTES } from './routes'

/**
 * F-103: the two answering screens. `/_/surveys/{id}` is the member's (inside the
 * app, with a session); `/s/{publicToken}` is the public link (no login, full
 * screen, the survey's community branding). Neither sends analytics (§6.6).
 */
const firstSegmentAfter = (path: string, prefix: string): string =>
  decodeURIComponent(path.slice(prefix.length).split(/[/?#]/)[0] || '').trim()

export const isSurveyAnswerPath = (path: string): boolean => path.startsWith(ROUTES.surveyAnswer)
export const isPublicSurveyPath = (path: string): boolean => path.startsWith(ROUTES.publicSurvey)
export const isSurveyPath = (path: string): boolean => isSurveyAnswerPath(path) || isPublicSurveyPath(path)

export const surveyIdFrom = (path: string): string => firstSegmentAfter(path, ROUTES.surveyAnswer)
export const publicSurveyTokenFrom = (path: string): string => firstSegmentAfter(path, ROUTES.publicSurvey)

export const surveyAnswerUrl = (id: string): string => `${window.location.origin}${ROUTES.surveyAnswer}${id}`
